import React, { Suspense, useContext } from 'react';
import AddDeviationToobarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/Deviation';
import GalleryToobarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/Gallery';
import VideoToobarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/Video';
import ReactionToobarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/Reaction';
import HRuleToobarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/HRule';
import GifToobarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/Gif';
import MuroToolbarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/MuroComment';
import { EditorContext } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';

import s from './CommentBoxToolbar.scss';

interface Props {
  width: number | undefined;
}

const CommentBoxToolbar: React.FC<Props> = ({ width }) => {
  const { ref: editor } = useContext(EditorContext);

  return (
    editor && (
      // Suspense required since these buttons include a dynamically loaded translation namespace
      <Suspense>
        <div className={s['root']} style={{ width: width ?? 'auto' }}>
          <AddDeviationToobarButton editor={editor} />
          <GalleryToobarButton editor={editor} />
          <VideoToobarButton editor={editor} />
          <ReactionToobarButton editor={editor} />
          <HRuleToobarButton editor={editor} />
          <GifToobarButton editor={editor} />
          <MuroToolbarButton editor={editor} />
        </div>
      </Suspense>
    )
  );
};

CommentBoxToolbar.displayName = 'CommentBoxToolbar';

export default CommentBoxToolbar;
